<template>
  <div>
    <el-dialog
      :title="editType === 'add' ? '新增' : '编辑'"
      :visible.sync="visible"
      :close-on-click-modal="false"
      @close="blackDeviceIpDailogClose"
      append-to-body
      :width="`${900}px`"
    >
      <el-form ref="form" label-position="right" :model="formChild" :rules="formRules" label-width="120px">
        <el-form-item label="标题" prop="title">
          <el-input style="width: 520px" v-model="formChild.title" placeholder="请输入标题"></el-input>
        </el-form-item>
        <el-form-item label="上传文件" prop="file">
          <el-upload
            ref="upload"
            class="upload-demo"
            action="#"
            :auto-upload="false"
            :on-change="handleFileChange"
            :on-remove="handleFileRemove"
            :before-upload="beforeUpload"
            :file-list="fileList"
            :limit="1"
            :multiple="false"
            :accept="acceptTypes"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">
              <p>说明:</p>
              <p>1、上传格式为 .zip；</p>
              <p>2、压缩包解压后为2文本文件，分别为 ID黑名单、IP黑名单； </p>
            </div>
          </el-upload>  
        </el-form-item>
        
        <!-- 文件预览 - 修复引用 -->
        <el-form-item v-if="formChild.file" label="文件信息">
          <div class="file-info">
            <i class="el-icon-document"></i>
            <span class="file-name">{{ formChild.file.name }}</span>
            <span class="file-size">{{ formatFileSize(formChild.file.size) }}</span>
            <el-button 
              type="text" 
              size="mini" 
              @click="removeFile"
              style="margin-left: 10px;"
            >
              删除文件
            </el-button>
          </div>
        </el-form-item>
      </el-form>
      
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" icon="el-icon-circle-check" @click="submitForm" :loading="submitting">
          提交
        </el-button>
        <el-button size="small" type="info" icon="el-icon-circle-close" @click="blackDeviceIpDailogClose">
          取消
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { add } from '@/api/ad/blackdeviceip'

export default {
  props: {
    blackDeviceIpDailogFlag: {
      type: Boolean,
      default: false
    },
    editId: {
      type: String,
      default: ''
    },
    editType: {
      type: String,
      default: 'add'
    },
    row: {
      type: Object,
      default: () => ({})
    }
  },
  
  data() {
    return {
      visible: false,
      acceptTypes: ".zip,application/zip,application/x-zip,application/x-zip-compressed",
      formChild: {
        title: '',
        file: null
      },
      fileList: [],
      formRules: {
        title: [{
          required: true, message: '请输入标题', trigger: 'blur'
        }],
        file: [
          { 
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error('请上传文件'));
              } else {
                callback();
              }
            }, 
            trigger: 'change' 
          }
        ]
      },
      submitting: false
    }
  },
  
  mounted() {
    this.visible = this.blackDeviceIpDailogFlag;
  },
  
  methods: {
    // 文件上传前验证
    beforeUpload(file) {
      // 验证文件大小
      const maxSize = 10 * 1024 * 1024; // 10MB
      if (file.size > maxSize) {
        this.$message.error(`文件 ${file.name} 超过10MB限制`);
        return false;
      }
      
      // 验证文件类型
      const allowedTypes = [
        'application/zip',
        'application/x-zip',
        'application/x-zip-compressed'
      ];
      
      const isValidType = allowedTypes.includes(file.type) || 
                         /\.zip$/i.test(file.name);
      
      if (!isValidType) {
        this.$message.error(`文件 ${file.name} 格式不支持，只能上传ZIP文件`);
        return false;
      }
      
      return true;
    },
    
    // 文件变化处理
    handleFileChange(file, fileList) {
      if (fileList.length > 0) {
        // 只取第一个文件
        const selectedFile = fileList[0];
        this.formChild.file = selectedFile.raw || selectedFile;
        this.fileList = fileList;
      } else {
        this.formChild.file = null;
        this.fileList = [];
      }
    },
    
    // 文件移除处理
    handleFileRemove(file, fileList) {
      this.formChild.file = null;
      this.fileList = fileList;
    },
    
    // 手动移除文件
    removeFile() {
      this.formChild.file = null;
      if (this.$refs.upload) {
        this.$refs.upload.clearFiles();
      }
      this.fileList = [];
    },
    
    // 格式化文件大小
    formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    },
    
    // 提交表单
    async submitForm() {
      try {
        // 表单验证 - 修复引用错误
        const valid = await this.$refs.form.validate();
        if (!valid) {
          return;
        }
        
        this.submitting = true;
        
        // 创建FormData对象
        const formData = new FormData();
        
        // 添加表单字段
        formData.append('title', this.formChild.title);
        
        // 添加文件
        if (this.formChild.file) {
          formData.append('file', this.formChild.file);
        }
        
        // 调用API
        const response = await add(formData);
        
        if (response.data.code === 200) {
          this.$message.success('提交成功!');
          this.resetForm();
          this.$emit('submit-success', response);
          this.blackDeviceIpDailogClose();
        } else {
          this.$message.error(response.data.msg || '提交失败');
        }
        
      } catch (error) {
        console.error('提交失败:', error);
        this.$message.error('表单提交失败，请重试');
      } finally {
        this.submitting = false;
      }
    },
    
    // 重置表单 - 添加安全检查
    resetForm() {
      this.formChild.title = '';
      this.formChild.file = null;
      this.fileList = [];
      
      // 添加安全检查，确保 $refs.form 存在
      if (this.$refs.form) {
        this.$refs.form.clearValidate();
      }
      
      if (this.$refs.upload) {
        this.$refs.upload.clearFiles();
      }
    },
    
    // 重置文件
    resetFiles() {
      this.formChild.file = null;
      this.fileList = [];
      if (this.$refs.upload) {
        this.$refs.upload.clearFiles();
      }
    },
    
    // 关闭对话框
    blackDeviceIpDailogClose() {
      this.resetForm();
      this.visible = false;
      this.$emit('update:blackDeviceIpDailogFlag', false);
    }
  },
  
  watch: {
    blackDeviceIpDailogFlag(val) {
      this.visible = val;
      // 移除这里的 resetForm 调用，避免过早调用
      if (val) {
        // 只重置数据，不调用可能引用未初始化的方法
        this.formChild.title = '';
        this.formChild.file = null;
        this.fileList = [];
      }
    },
    
    editType(val) {
      if (val === 'add') {
        // 只重置数据，不调用可能引用未初始化的方法
        this.formChild.title = '';
        this.formChild.file = null;
        this.fileList = [];
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.file-info {
  display: flex;
  align-items: center;
  padding: 10px;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  background-color: #fafafa;
}

.file-info i {
  margin-right: 8px;
  color: #409eff;
}

.file-name {
  flex: 1;
  margin-right: 10px;
  word-break: break-all;
}

.file-size {
  color: #909399;
  font-size: 12px;
}

.el-upload__tip {
  color: #909399;
  font-size: 12px;
  line-height: 1.5;
}
</style>